import styled from 'styled-components';
import { getColorShade, getColor, getSizeBy, getThemeProp } from '../../../../../src/styled/utils';
export const StyledFileListItem = styled.li `
  margin-top: ${getSizeBy(2)};
  border: 1px solid
    ${({ $isError }) => ($isError ? getColor('danger') : getColorShade('onSurface', 'outline'))};
  border-radius: ${getThemeProp('borderRadius')}px;
`;
